import React from 'react';

import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomAlert = styled(Alert)({
  paddingY: 0,
  fontWeight: 'bold',
  fontSize: 20,
});

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

function WarningExistingExperienceItems({ open, onClose, onConfirm }: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle fontSize={24} fontWeight="bold">
        Warning
      </DialogTitle>
      <DialogContent sx={{ minWidth: '400px' }}>
        <DialogContentText>
          <CustomAlert severity="error" icon={false}>
            This order has some experiences items. Please check them below and cancel to prevent partial cancellations.
          </CustomAlert>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          I understand
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WarningExistingExperienceItems;
